import { render, staticRenderFns } from "./SelectPartyToSendDelegate.vue?vue&type=template&id=6d45cadc&"
import script from "./SelectPartyToSendDelegate.vue?vue&type=script&lang=ts&"
export * from "./SelectPartyToSendDelegate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports